import { Component, OnInit } from "@angular/core";
import { AuthenticationService } from "../../../../auth/service";
import { Router } from "@angular/router";
import { UtilsService } from "../../../../auth/service/utils.service";
import { AssetsService } from "../../assets.service";
import { AssetCategoriesService } from "../../asset-categories.service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { IAssetCategory } from "../../models/assets";

@Component({
  selector: "app-asset-import",
  templateUrl: "./asset-import.component.html",
  styleUrls: ["./asset-import.component.scss"],
})
export class AssetImportComponent implements OnInit {
  public contentHeader: IContentHeader;
  public xlsx_file_content: any;
  public fileName: string = null;
  public uploadStarted: boolean = false;
  private assets_categories: IAssetCategory[] = [];

  constructor(
    private _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
    private _assetsService: AssetsService,
    private _assetsCategoriesService: AssetCategoriesService,
    public _router: Router,
  ) {
    this.contentHeader = {
      headerTitle: "MENU.ASSET_CATEGORIES",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "ASSETS",
            isLink: true,
            link: "/dashboard/assets/list",
          },
          {
            name: "IMPORT",
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("asset_import")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }

    this.assets_categories = await this._assetsCategoriesService.getCategoriesList();
  }

  async save() {
    this.uploadStarted = true;

    for (let item of this.xlsx_file_content.slice(0, 5)) {
      const foundCategory = this.assets_categories.find((cat: IAssetCategory) => cat.name === item.category_name);
      if (!foundCategory) {
        await this._assetsCategoriesService.createCategory({ name: item.category_name, parent_id: null, description: null }).then((r: { id: number }) => {
          if (!!r.id) {
            this.assets_categories.push({ id: r.id, name: item.category_name, description: null, child: [], parent_id: null, isAChild: false });
          }
        });
      }
    }

    await Promise.all(
      this.xlsx_file_content
        .map(async (item) => {
          let categoryId: number = 0;

          const foundCategory = this.assets_categories.find((cat: IAssetCategory) => cat.name === item.category_name);
          if (foundCategory) {
            categoryId = foundCategory.id;
          } else {
            item.status = 3;
            item.status_note = "Impossibile creare la categoria";
            return false;
          }

          item.status = 1;

          await this._assetsService
            .createAsset(
              {
                name: item.name || "",
                serial: item.serial || "",
                product_serial_number: item.product_serial_number || "",
                contract_end_date: item.contract_end_date ? item.contract_end_date : null,
                license_end_date: item.license_end_date ? item.license_end_date : null,
                license_auto_renew: item.license_auto_renew ? item.license_auto_renew : null,
                contract: item.contract.toString() || "",
                description: item.description || "",
                category: categoryId,
                rented: item.contract.toString() > 0 ? 1 : 0,
              },
              false,
            )
            .then(() => {
              item.status = 2;
            });
        })
        .then(() => this._assetsService.getAllAssets()),
    );
  }

  async downloadTemplate() {
    return this._utilService.document_file("static-template/template-import-assets.xlsx");
  }

  async handlerChangeFileInput($event: any) {
    this.fileName = $event.target.files[0].name;
    if ($event.target.files && $event.target.files[0]) {
      this._utilService.parseXLSX(
        $event.target.files[0],
        ["serial", "category_name", "name", "product_serial_number", "description", "contract", "contract_end_date"],
        { raw: true, defval: "", header: ["A", "B", "C", "D", "E", "F", "G"], cellDates: false },
        (data: any) => {
          this.xlsx_file_content = data.slice(1).map((item: any) => {
            item.contract_end_date = item.contract_end_date.replace(/_/gi, "-");
            item.description = item.description.replace(/\r/gi, "<br>").replace(/\n/gi, "<br>");
            item.status = 0;
            item.status_note = "";
            return item;
          });
        },
      );
    }
  }

  processedItems() {
    return this.xlsx_file_content.filter((item) => item.status > 1).length;
  }
}
